import React, { useState } from "react";
import { Modal, Header, Button, Form as FormUi, List } from "semantic-ui-react";
import Axios from "axios";
import cogoToast from "cogo-toast";
import { connect } from "react-redux";
import {
  successAlertDispatcher,
  errorAlertDispatcher,
} from "../../redux/actions/alertAction";
import { translate } from "react-i18next";
import {FILE_IMPORT} from '../../utils/toastMsgConstant'
import { LOCAL_STORAGE } from '../../utils/constant'
import { ERROR_MESSAGES, PROMPTS } from '../../utils/validationConstant'

const ImportFile = (props) => {
  const [file, setFile] = useState(0);
  const [isloading, setisloading] = useState(false);
  const [importMsg, setImportMsg] = useState([]);
  const [showResultModal, setShowResultModal] = useState(false);
  const handleFile = (e) => {
    let file = e.target.files[0];
    setFile(file);
  };
  const templateDownload = () => {
    // let fileName = props.fileName;
    // let url = `${process.env.REACT_APP_BASE_URL}/masters/static/${fileName}.xlsx`;
    // window.location.href = url;
    let customerNo = LOCAL_STORAGE.customerNo
    let fileName = `${props.fileName}.xlsx`;
    let url=`${process.env.REACT_APP_MASTER_API}/templateDownload/${customerNo}/${fileName}`;
    
    Axios.get(url,{
      headers: {
        "content-type": "multipart/form-data",
        Authorization: `${LOCAL_STORAGE.userToken}`,
      },
      responseType:'blob'}).then((res)=>{
      var data = new Blob([res.data]);
      
        var blob = data;
        var link = document.createElement('a');
        link.href = window.URL.createObjectURL(blob);
        link.download = fileName;
        document.body.appendChild(link);
        link.click(); 
      })
}


  const handleResultModalClose = () => {
    setImportMsg([]);
    setShowResultModal(false);
  }

  let handleUpload = (e) => {
    e.preventDefault();
    setisloading(true);
    if (file === "" || file === null || file === undefined) {
      setisloading(false);
      cogoToast.error(FILE_IMPORT.INVALID_FILE)
    } else if (
      file.type !==
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
    ) {
      setisloading(false);
      cogoToast.error(FILE_IMPORT.INVALID_FILE_FORMAT)
    } else {
      let fromData = new FormData();
      fromData.append("myfile", file);
      fromData.append("customerNumber", LOCAL_STORAGE.customerNo);
      fromData.append("userId", LOCAL_STORAGE.userId);
      props.moduleName && fromData.append("module", props.moduleName) ;
      if(props.masterIdName && props.masterIdValue) fromData.append(props.masterIdName, props.masterIdValue) ;
      var gett = LOCAL_STORAGE.userToken
      var url = `${process.env.REACT_APP_MASTER_API}/import/${props.baseURL}`;
      Axios.post(url, fromData, {
        headers: {
          "content-type": "multipart/form-data",
          Authorization: `${gett}`,
        },
      })
        .then((response) => {
          if (response.data.status === 200) {
            if (response.data.resultSet.length > 0) {
              // //  check for message
              // if (response.data.resultSet[0].status === 200) {
              //   props.success({
              //     type: "success",
              //     messageHeader: "Success",
              //     messageBody: response.data.resultSet[0].message,
              //   });
              // } else {
              //   props.error({
              //     type: "error",
              //     messageHeader: "Error",
              //     messageBody: response.data.resultSet[0].message,
              //   });
              // }
              setShowResultModal(true)
              setImportMsg(response.data.resultSet)

            } else {
              setisloading(false);
              props.error({
                type: "error",
                messageHeader: "Error",
                messageBody: PROMPTS.NO_RECORDS_FOUND,
              });
              window.setTimeout(() => {
                window.location.reload();
              }, 2000);
            }
          }
          setisloading(false);
          // props.handleClose();
        })
        .catch((err) => {
          // alert(err.response.data.message);
          props.error({
            type: "error",
            messageHeader: "Error",
            messageBody: ERROR_MESSAGES.IMPORT_FAILED,
          });
          setisloading(false);
          console.log(">> err", err);
        });
    }
  };

  const { t } = props;
  return (
    <div>
      {importMsg.length > 0 ?
        <>
          <Modal open= {showResultModal} onClose={handleResultModalClose}>
            <div style={{ height: '200px', overflowY: 'scroll', padding: '20px' }}>
                {importMsg.map((o, i) => (
                    <>
                        <List className="p-2 pl-2 m-1 w3-border w3-border-blue">
                            <List.Item >
                                <List.Description> {`Record ${i + 1}:`}</List.Description>
                                <List.Header>{typeof o.message === 'object' ? o.message?.message : o.message}</List.Header>
                            </List.Item>
                        </List>
                    </>
                ))}
            </div>
            <center><button onClick={() => window.location.reload()} className="w3-button w3-small w3-blue w3-round w3-hover-blue p-outline-none m-2">{t("ok")||"OK"}</button></center>
          </Modal>
        </>
        :
      <>
      <Modal open={props.openBox} onClose={props.handleClose} size="tiny">
        <Header>{t("title") || "Import File"}</Header>
        <Modal.Content>
          <Modal.Description>
            <FormUi.Group inline>
              <FormUi.Field>
                <label className="tiny ui form p-bold-600">
                  {t("message") || "Import Data Using Excel Sheet(Format- xls,xlsx)."}
                </label>
              </FormUi.Field>
            </FormUi.Group>
            <FormUi.Group inline>
              <FormUi.Field>
                <label className="tiny ui form p-bold-300 w3-text-grey  pt-3">
                {t("upload_file") || "Upload File"} &nbsp;
                </label>
                <input
                  onChange={handleFile}
                  type="file"
                  className="w3-small"
                  id="validatedCustomFile"
                />
              </FormUi.Field>
              <FormUi.Field>
                <label className="tiny ui form pt-3">
                  <span className="p-bold-600 ">
                  {t("download") || "Download Excel Template from"}{" "}
                    <span
                      className="w3-text-blue p-bold-300"
                      onClick={templateDownload}
                      style={{ cursor: "pointer" }}
                    >
                      {t("here") || "Here"}
                    </span>
                  </span>
                </label>
              </FormUi.Field>
            </FormUi.Group>
          </Modal.Description>
        </Modal.Content>
        <Modal.Actions>
          {isloading ? <small>{PROMPTS.LOADING}</small> : ""}
          <Button onClick={props.handleClose} size="mini">
          {t("cancel") || "Cancel"}
          </Button>
          <Button
            onClick={handleUpload}
            disabled={isloading ? true : false}
            color="blue"
            size="mini"
          >
            {t("upload") || "Upload"}
          </Button>
        </Modal.Actions>
      </Modal>
      </>}
    </div>
  );
};

const mapDispatchToProps = (dispatch) => {
  return {
    success: (alert) => dispatch(successAlertDispatcher(alert)),
    error: (alert) => dispatch(errorAlertDispatcher(alert)),
  };
};

export default connect(null, mapDispatchToProps)(translate("importfilemaster")(ImportFile));
